import React, {useContext, useEffect, useState} from 'react';
import {WMSContext} from "../../../../context/WMSContext";
import {getWMSContainersWithType} from "../../../../../../api/wms/wmsContainers/wmsContainers";
import {WmsContainerType} from "../../../../../../utils/WMSContainerType";
import {Card, CardContent, Grid} from "@mui/material";
import DisplayHive from "./components/DisplayHive";
import {greyishBlue50, greyishBlue300, blueColor, orange600, green600, red600} from "../../../../../../assets/jss/main";
import pusherClient from "../../../../../../utils/pusherClient";
import {FormattedMessage} from "react-intl";
import Badge from "../../../../../../components/Badge";
import BeatLoaderRegular from "../../../../../../components/loaders/BeatLoaderRegular";

function HiveList() {
    const {currentInventory, currentOrganization, isMobile} = useContext(WMSContext)

    const [loading, setLoading] = useState(true)
    const [hives, setHives] = useState([])

    const toInt = (value) => Number.isInteger(value) ? value : null

    const refactorByHive = (containers) => {
        const hiveMap = {}
        containers.forEach((container) => {
            if (!hiveMap[container.hiveName]) {
                hiveMap[container.hiveName] = {
                    hiveOrder: Infinity,
                    rowSize: null,
                    containers: []
                }
            }
            const hive = hiveMap[container.hiveName]

            hive.hiveOrder = Math.min(hive.hiveOrder, toInt(container.metadata?.hiveOrder) ?? Infinity)

            const containerRowSize = toInt(container.metadata?.rowSize)
            if (containerRowSize != null) {
                hive.rowSize = hive.rowSize != null ? Math.min(hive.rowSize, containerRowSize) : containerRowSize
            }

            hive.containers.push({
                name: container.name,
                id: container.id,
                codebar: container.codebar,
                maxCapacity: container.maxCapacity,
                wmsItems: container.wmsItems,
                displayOrder: toInt(container.metadata?.displayOrder) ?? Infinity,
            })
        })

        return Object.entries(hiveMap)
            .map(([hiveName, {hiveOrder, rowSize, containers}]) => ({
                hiveName,
                hiveOrder,
                rowSize,
                containers: containers.sort((a, b) => a.displayOrder - b.displayOrder)
            }))
            .sort((a, b) => a.hiveOrder - b.hiveOrder)
    }

    useEffect(() => {
        if (currentInventory) {
            getWMSContainersWithType(WmsContainerType.HIVE, currentInventory.id, false).then((response) => {
                setHives(refactorByHive(response))
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [currentInventory]);

    useEffect(() => {
        if (!currentInventory || !currentOrganization) return;

        const channelName = 'wms_item_' + currentInventory.id + currentOrganization.id;
        const channel = pusherClient.subscribe(channelName);

        channel.bind('status_changed', (data) => {
            setHives((prevHives) => prevHives.map((hive) => ({
                ...hive,
                containers: hive.containers.map((container) => {
                    if (container.codebar !== data.containerCodebar) return container;

                    return {
                        ...container,
                        wmsItems: container.wmsItems.map((wmsItem) =>
                            wmsItem.id === data.updatedWmsItem.id ? data.updatedWmsItem : wmsItem
                        ),
                    };
                }),
            })));
        });

        return () => {
            channel.unbind('wms_item_');
            pusherClient.unsubscribe('private-' + channelName);
        };
    }, [currentInventory, currentOrganization]);

    return (
        <Grid container direction={"column"} gap={"8px"} sx={{marginTop: '2%'}}>

            <span style={{fontWeight: "bold", color: blueColor}}><FormattedMessage id={"wms.admin.hiveList.title"} /></span>

            <Card
                sx={{
                    backgroundColor: greyishBlue50,
                    borderRadius: "8px",
                    border: "1px solid "+greyishBlue300,
                    ...(isMobile ? {maxHeight: "40vh"} : {}),
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                }}
            >
                <CardContent sx={{overflowY: "auto", flex: 1}}>
                    {loading && (
                        <BeatLoaderRegular loading={loading}/>
                    )}

                    {!loading && (
                        <Grid container direction={"column"}>
                            <Grid container direction={isMobile ? "column" : "row"} wrap={"wrap"} columnGap={"32px"} alignItems={"flex-start"}>
                                {hives.map((hive) => {
                                    return (
                                        <Grid item key={hive.hiveName} xs={isMobile ? 12 : "auto"}>
                                            <DisplayHive hive={hive} />
                                        </Grid>
                                    )
                                })}
                            </Grid>

                            <Grid container>
                                <Badge indicator indicatorColor={'#FFFFFF'} color={"info"}><FormattedMessage id={"wms.admin.hiveList.legends.empty"}/></Badge>
                                <Badge indicator indicatorColor={orange600} color={"info"}><FormattedMessage id={"wms.admin.hiveList.legends.incomplete"}/></Badge>
                                <Badge indicator indicatorColor={green600} color={"info"}><FormattedMessage id={"wms.admin.hiveList.legends.ready"}/></Badge>
                                <Badge indicator indicatorColor={red600} color={"info"}><FormattedMessage id={"wms.admin.hiveList.legends.incomplete&Late"}/></Badge>
                            </Grid>

                        </Grid>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}

export default HiveList;